import React from "react";
import { cn } from "@/lib/utils";

const SIZES = {
    sm: "min-h-11 px-5 py-2 text-sm",
    md: "min-h-11 px-7 py-3 text-sm sm:text-base",
    lg: "min-h-12 px-9 py-4 text-base sm:text-lg",
    block: "min-h-12 w-full px-7 py-4 text-base",
};

// Solid accent pill button (calm system): glow removed, visible focus ring,
// 44px minimum target. `pulse` is accepted for call-site compatibility.
export const NeonButton = React.forwardRef(
    (
        {
            children,
            size = "md",
            className,
            pulse = true,
            disabled = false,
            type = "button",
            ...props
        },
        ref,
    ) => {
        return (
            <button
                ref={ref}
                type={type}
                disabled={disabled}
                className={cn(
                    "rf-heading relative inline-flex items-center justify-center gap-2 rounded-full font-semibold text-white",
                    "bg-purple-600 select-none",
                    "transition-[background-color,transform] duration-200 hover:bg-purple-500 active:scale-[0.98]",
                    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-300 focus-visible:ring-offset-2 focus-visible:ring-offset-black",
                    disabled && "opacity-40 cursor-not-allowed",
                    SIZES[size],
                    className,
                )}
                {...props}
            >
                <span className="relative z-10 flex items-center gap-2">
                    {children}
                </span>
            </button>
        );
    },
);
NeonButton.displayName = "NeonButton";
